import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex); 
 
//声明Vuex 的五个属性，其中state,mutations 是一定要定义的，其他的三个属性对象根据实际需要。
const state = {  // 初始化状态值--一定要有该属性对象  
    alarmNum:0//报警未读条数       
}
const mutations = {  // 自定义改变state初始值的方法--一定要有该属性对象
    updateAlarm (state,num) {
       state.alarmNum = num
    }
}
const getters = {  // 状态计算属性--该属性对象不是必须的            
}
const actions = { // 异步操作状态--该属性对象不是必须的
    // updateAlarm(num){
    //     state.alarmNum = num;
    // }
}
const modules = {  // 状态模块--该属性对象不是必须的
}
 
//创建一个 store 实例，将声明的五个变量赋值赋值给 store 实例，如下：
const store = new Vuex.Store({
   state,
   mutations,
    //下面三个非必须
   getters,
   actions,
   modules
})
//导出 store 实例，供外部访问
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js